import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiMethod } from '../const/requests-methods';

@Injectable({
    providedIn: 'root'
})

export class HttpService {

    constructor(private http: HttpClient) { }

    public requestCall(api, method: ApiMethod, headers?: any, data?: any) {
        let response;

        switch (method) {
            case ApiMethod.GET:
                response = this.http.get(`${api}`, { ...headers, withCredentials: true })
                    .pipe(catchError((error) => throwError(error)));
                break;
            case ApiMethod.POST:
                response = this.http.post(`${api}`, data, { ...headers, withCredentials: true })
                    .pipe(catchError((error) => throwError(error)));
                break;
            case ApiMethod.DELETE:
                response = this.http.delete(`${api}`, { ...headers, withCredentials: true })
                    .pipe(catchError((error) => throwError(error)));
                break;
            default:
                break;
        }

        return response;
    }
}
